jQuery.feature_import(
  "js-upgrade-page",
  () => require("./UpgradePage"),
  (mod) => mod.feature_js_upgrade_page
);
